import { User } from "./user";

export class Employee {
  id: number;
  idExternal: number;
  name: string;
  cpf: string;
  user: User;
}
